import {
  setupComposedChart,  
  setupCustomerUser,
  setupDashboard,
  setupDataEntry,
  setupMessage,
  setupOsGenerated,
  setupOsOpenedGraphics,
  setupResolutionTime,
  setupSla,
} from './module-registry';

function setup(): void {
  setupDashboard();
  setupMessage();
  setupResolutionTime();
  setupSla();
  setupOsOpenedGraphics();
  setupOsGenerated();
  setupDataEntry();
  setupComposedChart();
  setupCustomerUser();
}

export {
  setup,
};

